import React, { useState } from "react"
import { useSelector } from "react-redux"
import { Transition } from "@headlessui/react"

const CurrentModeDialogue = () => {
	const isTomorrowMode = useSelector(state => state.tomorrow.isTomorrowMode)
	const sandbox = useSelector(state => state.sandbox.isSandboxMode)
	const [show] = useState(true)

	return (
		<>
			<div
				aria-live="assertive"
				className="pointer-events-none absolute inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
			>
				<div className="flex w-full flex-col items-center space-y-4 sm:items-end">
					<Transition show={show}>
						<div className="pointer-events-auto w-full max-w-xs overflow-hidden rounded-lg bg-customBlue-dark shadow-lg ring-1 ring-black/5 transition">
							<div className="p-4">
								<div className="flex items-center">
									<div className="flex w-0 flex-1 justify-between">
										<p className="w-0 flex-1 text-sm font-medium text-white">
											Current Mode:{" "}
											{isTomorrowMode
												? "Tomorrow"
												: sandbox
													? "Sandbox"
													: "Today"}
										</p>
									</div>
								</div>
							</div>
						</div>
					</Transition>
				</div>
			</div>
		</>
	)
}

export default CurrentModeDialogue
